import React from 'react';

export const settingsSideNavLinks = [
  {
    id: 1,
    text: 'Account',
    link: '/account'
  },
  {
    id: 2,
    text: 'Notifications',
    link: '/account_notifications'
  },
  {
    id: 3,
    text: 'Playback and performance',
    link: '/account_playback'
  },
  {
    id: 4,
    text: 'Privacy',
    link: '/account_privacy'
  },
  {
    id: 5,
    text: 'Connected apps',
    link: '/account_sharing'
  },
  {
    id: 6,
    text: 'Billing and payments',
    link: '/account_billing'
  },
  {
    id: 7,
    text: 'Advanced settings',
    link: '/account_advanced'
  },
];
